// Platform UI copy only. User-authored and brand content never belongs here.
export const translationResources = {
  ru: {
    nativeName: "Русский",
    messages: {
      "common.back": "Назад",
      "common.continue": "Продолжить",
      "common.save": "Сохранить",
      "language.selector.label": "Язык интерфейса",
      "language.selector.saveError": "Не удалось сохранить язык",
      "shared.profile": "Профиль",
      "shared.signOut": "Выход",
      "proof.ruFallbackOnly": "Доступно на русском",
      "voice.proof.menu": "Проверка Voice Foundation",
    },
  },
  en: {
    nativeName: "English",
    messages: {
      "common.back": "Back",
      "common.continue": "Continue",
      "common.save": "Save",
      "language.selector.label": "Interface language",
      "language.selector.saveError": "Could not save the language",
      "shared.profile": "Profile",
      "shared.signOut": "Sign out",
    },
  },
};
